export default {
  CHILD_DEVELOPMENT: "子女成長",
  EDU_AND_CAREERS: "升學及就業資訊",
  E_LEARNING: "電子學習及輔助學習工具",
  PARENT_CHILD: "親子關係",
  PARENT_SCH: "家校溝通",
  READING: "閱讀",
  SELF_LEARNING: "自主學習及獎勵計劃",
  SPECIAL: "特殊學習需要",
};
